<template>
  <section
    ref="sectionEl"
    :id="computedId"
    class="section-component-panel"
    role="sectionpanel"
  >
    <slot />
  </section>
</template>

<script setup lang="ts">
export interface SectionRegistration {
  _isSection: boolean
  name: string
  icon: string | string[]
  visible?: boolean
  el: HTMLElement | null
}

interface Props {
  id?: string | null
  name: string
  icon: string | string[]
  prefix?: string
  suffix?: string
  isDisabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  id: null,
  prefix: '',
  suffix: '',
  isDisabled: false,
})

const sectionEl = ref<HTMLElement | null>(null)

const header = computed(() => {
  return props.prefix + props.name + props.suffix
})

const computedId = computed(() => {
  return props.id ? props.id : props.name.toLowerCase().replace(/ /g, '-')
})

const hash = computed(() => {
  if (props.isDisabled) {
    return '#'
  }
  return '#' + computedId.value
})

// Registration object exposed to parent Scrollspy component
const registration = reactive<SectionRegistration>({
  _isSection: true,
  name: props.name,
  icon: props.icon,
  el: null,
})

watch(() => props.name, (val) => { registration.name = val })
watch(() => props.icon, (val) => { registration.icon = val })

// Inject register/unregister from parent Scrollspy
const register = inject<((section: SectionRegistration) => void) | null>('scrollspy-register', null)
const unregister = inject<((section: SectionRegistration) => void) | null>('scrollspy-unregister', null)

onMounted(() => {
  registration.el = sectionEl.value
  register?.(registration)
})

onBeforeUnmount(() => {
  unregister?.(registration)
})

defineExpose({ _isSection: true, header, computedId, hash, name: props.name, icon: props.icon })
</script>
